import {isElement, isNil, isString} from 'lodash';

import {LIBRARY_NAME} from 'src/js/common/constants';
import LogUtils from 'src/js/common/utils/log_utils';

const logger = LogUtils.getLogger('RawRenderingService', LIBRARY_NAME);

const RawRenderingService = {
  /* eslint-disable no-param-reassign */
  appendChildNodeOrHtml(node, child) {
    if (isElement(node)) {
      if (isString(child)) {
        if (isNil(node.innerHTML)) {
          node.innerHTML = '';
        }
        node.innerHTML += child;
      } else if (isElement(child)) {
        node.appendChild(child);
      } else if (!isNil(child)) {
        logger.error('Trying to render non-string and non-element child.');
      }
    } else {
      logger.error('Trying to append child in non-element node.');
    }

    return node;
  },

  setNodeStyle(node, style) {
    if (style) {
      Object.keys(style).forEach((styleProperty) => {
        node.style[styleProperty] = style[styleProperty];
      });
    }

    return node;
  },
  /* eslint-enable no-param-reassign */
};

export default RawRenderingService;
